export var HighPremiumDiscountEGLType;
(function (HighPremiumDiscountEGLType) {
    HighPremiumDiscountEGLType["HIGHPREMIUM"] = "highPremium";
    HighPremiumDiscountEGLType["HIGHDISCOUNT"] = "highDiscount";
})(HighPremiumDiscountEGLType || (HighPremiumDiscountEGLType = {}));
